import { render, staticRenderFns } from "./BkashPromotionBannerEdit.vue?vue&type=template&id=2d7743fd&scoped=true&"
import script from "./BkashPromotionBannerEdit.vue?vue&type=script&lang=js&"
export * from "./BkashPromotionBannerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7743fd",
  null
  
)

export default component.exports